var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['v-dynamic-grid-cell', { 'v-dynamic-grid-cell--header': _vm.head }, { 'sortable-header': _vm.sortable }],style:(_vm.contentStyle),on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }